import { lazy } from 'react';

const AuthorisedFoodAidRoute = lazy(
  () => import('../components/steps/authorised-food-aid-step/AuthorisedFoodAid'),
);

export default AuthorisedFoodAidRoute;
